import FacebookPage from "@/managers/data/facebook/facebookPage"
import InstagramBusinessAccount from "@/managers/data/instagram/InstagramBusinessAccount"
import Publishers from "@/managers/organization/publishers"

export default class Service {
	public externalId: string
	public externalName: string | null
	public publisherId: number

	public get isFacebook(): boolean {
		return this.publisherId === Publishers.facebookId
	}

	public get isInstagram(): boolean {
		return this.publisherId === Publishers.instagramId
	}

	public get url(): string | null {
		return this.isFacebook
			? FacebookPage.getUrlFromId(this.externalId)
			: this.isInstagram && this.externalName !== null
				? InstagramBusinessAccount.getUrlFromUsername(this.externalName!)
				: null
	}

	constructor(externalId: string, name: string | null, publisherId: number) {
		this.externalId = externalId
		this.externalName = name
		this.publisherId = publisherId
	}

	public compare(value: Service): number {
		if (value.publisherId !== this.publisherId)
			return this.publisherId - value.publisherId

		if (value.externalName !== this.externalName)
			return (this.externalName ?? "").localeCompare(value.externalName ?? "")

		return this.externalId.localeCompare(value.externalId)
	}
}
